import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    floatingButtonContainer: {
      padding: '16px 0px',
      position: 'sticky',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bottom: 0,
      backgroundColor: theme.palette.background.default,
    },
  });

export default styles;
